import PresetItemInterface from "../../../interfaces/PresetItemInterface";
import PresetInterface from "../../../interfaces/PresetInterface";

export default function GetItemVat (preset: PresetInterface, item: PresetItemInterface, pretty = true): number|string {
    let value = 0
    if (preset.checkboxes.count > 0 && preset.checkboxes.nds > 1) {
        let countField = item.custom_fields.filter((f) => f.id === 1)
        let sumField = item.custom_fields.filter((f) => f.id === preset.checkboxes.sum)
        let saleField = item.custom_fields.filter((f) => f.id === preset.checkboxes.sale)

        if (countField.length > 0 && sumField.length > 0) {

            let price = parseInt(countField[0].values[0].value) * parseFloat(sumField[0].values[0].value)

            if (saleField.length > 0) {
                price -= parseInt(countField[0].values[0].value) * parseFloat(saleField[0].values[0].value)
            }

            if ([2, 3].indexOf(preset.checkboxes.nds) > -1) {
                value = price * 0.1
            } else if ([4, 5].indexOf(preset.checkboxes.nds) > -1) {
                value = price * 0.2
            } else if ([6, 7].indexOf(preset.checkboxes.nds) > -1) {
                value = price * 0.18
            }

        }
    }
    if (pretty) {
        return value.toLocaleString('ru-RU') + " ₽"
    }
    return parseFloat(value.toFixed(2))
}
